import { Component, Output, forwardRef, EventEmitter, Input, ChangeDetectorRef, OnInit, input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AcsService } from "../../service/communication.service";
import { VoiceRecognitionService } from "../../service/voice-recognition.service";
import { lastValueFrom, Subscription } from 'rxjs';
import { VoiceRecordingService } from "../../service/voice-recording.service";
import { DomSanitizer } from "@angular/platform-browser";
import { CoreHelperService } from "src/app/providers/core-helper/core-helper.service";
import { CallLogService } from "../call-log-dialog/call-log.services";
import { TransactionMode } from "../../enum/transaction-mode";
import { CallRefferenceType } from "../../enum/call-log";
import { documentsService } from "src/app/modules/auth/services/document/document.services";
import { CommonNotificationService } from "../../service/common-notification.service";

@Component({
  selector: 'app-phone-dialer',
  templateUrl: './phone-dialer.component.html',
  styleUrl: './phone-dialer.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PhoneDialerComponent),
      multi: true
    }
  ]
})

export class PhoneDialerComponent implements OnInit {

  //Parameters
  @Output() onPhoneDialerCloseEvent: EventEmitter<any> = new EventEmitter<any>();
  @Input() paramCallRefferenceType: CallRefferenceType;
  @Input() paramObjectId: number = 0;
  @Input() showPhoneDialerClose: boolean = false;
  @Input() paramPhoneCountryCode: string = "";
  @Input() paramPatientId: number = 0;


  //Local Dialer Method
  currentValue = ""; //valor actual
  onChange = (_: any) => { }; //funcion que recibe valor que cambio
  onTouch = () => { }; //no recibe valores
  isDisabled = false; //setear disabled en componente


  //ACS Service
  dialerCallInProgress: boolean = false;
  dialerAcsServiceAvailable: boolean = false;
  validationMessage: string = "";
  isPhoneRequired: boolean = false;
  isInvalidPhone: boolean = false;

  //Voice Testing
  transcribedText = '';
  private speechSubscription: Subscription | undefined;

  //Call Voice Recording
  isRecordingDownloadable: boolean = false;
  isRecording = false;
  recordedTime: any;
  blobUrl: any;
  teste: any;

  //If Country Code is not available then don't allowed to use Dialer
  isCountryCodeAvailable: boolean = false;

  //DB Object
  currentCallLogId: number = 0;

  //User Browser/IP/Location Information
  callerInformation: string;
  callingPhoneNumber: string = '';

  //#region Page Life Cycle
  constructor(
    private _acsService: AcsService,
    public _voiceService: VoiceRecognitionService,
    private _recordingService: VoiceRecordingService,
    private _sanitizer: DomSanitizer,
    private _phoneLogService: CallLogService,
    public _coreHelperService: CoreHelperService,
    private _documentService: documentsService,
    private _notificationService: CommonNotificationService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {
    //Phone Voice Service
    this._voiceService.init()
    this._voiceService.voiceText = '';

    //Phone Call Recording
    this._recordingService
      .recordingFailed()
      .subscribe(() => (this.isRecording = false));
    this._recordingService
      .getRecordedTime()
      .subscribe(time => (this.recordedTime = time));
    this._recordingService.getRecordedBlob().subscribe(data => {
      this.isRecordingDownloadable = true;
      this.teste = data;
      this.blobUrl = this._sanitizer.bypassSecurityTrustUrl(
        URL.createObjectURL(data.blob)
      );
    });
  }

  ngOnInit(): void {
    this.isCountryCodeAvailable = (this.paramPhoneCountryCode.length > 0);
    if (this.isCountryCodeAvailable) {
      this._acsService.initializeAcsService();
      this.dialerAcsServiceAvailable = this._acsService.serviceAcsServiceAvailable;

      //Subscribed Deligate
      this.speechSubscription = this._voiceService.voiceText$.subscribe(voiceData => {
        this.transcribedText = voiceData;
      });
    }
  }

  ngAfterViewInit() {
    this.isCountryCodeAvailable = (this.paramPhoneCountryCode.length > 0);
    this.validationMessage = this._acsService.printCallMessage;
    this.changeDetectorRef.detectChanges();

    //Get IP/Latitude
    this._phoneLogService.getUserIP().subscribe((data: any) => {
      this.callerInformation = JSON.stringify(data);
      console.log('-- callerInformation --', this.callerInformation);
    });
  }

  ngDoCheck() {
    if (this.isCountryCodeAvailable) {
      this.dialerAcsServiceAvailable = this._acsService.serviceAcsServiceAvailable;
      this.validationMessage = this._acsService.printCallMessage;
      this.changeDetectorRef.detectChanges();
    }
  }

  ngOnDestroy(): void {
    if (this.speechSubscription)
      this.speechSubscription.unsubscribe();

    this.abortRecording();
  }
  //#endregion


  destroySpeechSynthesis() {
    window.speechSynthesis.cancel()
  }

  //#region ADD DB LOG
  getRecordingFileByType(isMp3: boolean = false) {
    let now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    let recordingFileName = '';
    let phoneNo = this.callingPhoneNumber.replace(`+${this.paramPhoneCountryCode}`, '');
    if (isMp3)
      recordingFileName = `VobRec_${phoneNo}_${hours}${minutes}${seconds}.mp3`;
    else
      recordingFileName = `VobTrns_${phoneNo}_${hours}${minutes}${seconds}.html`;
    return recordingFileName;
  }

  getAudioRecordingFile(theBlob: Blob): File {
    let fileName = this.getRecordingFileByType(true);
    const file = new File([theBlob], fileName, {
      lastModified: Date.now(),
      type: "audio/mpeg",
    });
    return file;
  }

  getAudioTextFile(): File {
    let fileName = this.getRecordingFileByType();
    const divElement = document.getElementById('recordingDiv');
    if (divElement) {
      const htmlContent = divElement.innerHTML;
      const theBlob = new Blob([htmlContent], { type: 'text/html' });
      const file = new File([theBlob], fileName, {
        lastModified: Date.now(),
        type: "text/html",
      });
      return file;
    }
    return null;
  }

  async addPhoneCallDBLog(logMode: TransactionMode) {
    if (this.paramCallRefferenceType == null)
      return;

    if (this.paramObjectId == null || this.paramObjectId == 0)
      return;

    let formData: FormData = new FormData();
    formData.set('CallLogId', this.currentCallLogId.toString());
    formData.set('CallTypeId', this.paramCallRefferenceType.toString());
    formData.set('CallObjectId', this.paramObjectId.toString());
    formData.set('CallerInfo', this.callerInformation.toString());
    formData.set('PhoneNumber', this.callingPhoneNumber.toString());
    formData.set('SpMode', logMode.toString());
    await lastValueFrom(this._phoneLogService.addUpdatePhoneCallLog(formData)).then(async (response) => {
      if (response.apiStatus) {
        this.currentCallLogId = parseInt(response.apiData.toString());
        if (logMode == TransactionMode.EditData && this.currentCallLogId > 0) {
          await this.uploadRecordingMp3();
        }
        console.log(`PhoneLogUpdate. ${this.currentCallLogId}`)
      }
    });
  }

  async uploadRecordingMp3() {
    let voiceRecordingFile = this.getAudioRecordingFile(this._recordingService.audioBlob);
    let formData = new FormData();
    formData.set('DocumentId', '0');
    formData.set('DocumentTypeId', '2');
    formData.set('DocumentDate', this._coreHelperService.getUtcDate(new Date()).toJSON());
    formData.set('CategoryId', '8');
    formData.set('SubCategoryId', '49');
    formData.set('PatientOrFacilityIds', this.paramPatientId.toString());
    formData.set('TagName', '');
    formData.set('StatusId', '1');
    formData.set('FileTypeId', '0');
    formData.set('InternalNotes', '');
    formData.set('ExternalNotes', '');
    formData.set('AssignToLead', '');
    formData.set('AssignToSpecialist', '');
    formData.set('ExpiryDate', '');
    formData.set('IsArchive', '1');
    formData.set('VobId', this.paramObjectId.toString());
    formData.set('IsRecording', '1');
    formData.set('ByDocumentId', '');
    formData.set('SpMode', '0');
    formData.delete('documentUpload');
    formData.append('documentUpload', voiceRecordingFile);
    await lastValueFrom(this._documentService.addUpdateDocument(formData)).then(async (response) => {
      if (response.apiStatus) {
        await this.uploadRecordingTextFile();
      }
    });
  }

  async uploadRecordingTextFile() {
    let voiceTextFile = this.getAudioTextFile();
    let formData = new FormData();
    formData.set('DocumentId', '0');
    formData.set('DocumentTypeId', '2');
    formData.set('DocumentDate', this._coreHelperService.getUtcDate(new Date()).toJSON());
    formData.set('CategoryId', '8');
    formData.set('SubCategoryId', '49');
    formData.set('PatientOrFacilityIds', this.paramPatientId.toString());
    formData.set('TagName', '');
    formData.set('StatusId', '1');
    formData.set('FileTypeId', '0');
    formData.set('InternalNotes', '');
    formData.set('ExternalNotes', '');
    formData.set('AssignToLead', '');
    formData.set('AssignToSpecialist', '');
    formData.set('ExpiryDate', '');
    formData.set('IsArchive', '1');
    formData.set('VobId', this.paramObjectId.toString());
    formData.set('IsRecording', '1');
    formData.set('ByDocumentId', ''); //mapped to created by/updated by columns - uses current user id in API
    formData.set('SpMode', '0');      //0 = insert, 1 = update, 2 = delete
    formData.delete('documentUpload');
    formData.append('documentUpload', voiceTextFile);
    await lastValueFrom(this._documentService.addUpdateDocument(formData)).then((response) => {
      if (response.apiStatus) {
        this._notificationService.displaySuccessMessage("Call recording uploaded successfully.");
      }
    });
  }

  //#endregion

  //#region Dialer Methods
  onPressDigit(digit: number | string) {
    this.isPhoneRequired = false;
    this.isInvalidPhone = false;

    if (this.currentValue.length > 9) {
      this.validationMessage = "Please dial number now."
      const phoneCallValue = this.currentValue.slice(0, -1);
      this.updateValue(phoneCallValue + digit);

    } else {
      const phoneCallValue = this.currentValue;
      this.updateValue(phoneCallValue + digit);
    }
  }

  onPressAsterisk() {
    //this.onPressDigit("*");
  }

  onPressNumeral() {
    //this.onPressDigit("#");
  }

  closePhoneDialerPopup(): void {
    this.showPhoneDialerClose = false;
    this.onPhoneDialerCloseEvent.emit();
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  setDisabledState(state: boolean): void {
    this.isDisabled = state;
  }

  //#endregion


  //#region ACS Service Methods
  async onCallDial() {
    this.isPhoneRequired = false;
    this.isInvalidPhone = false;

    if (this.isCountryCodeAvailable) {

      //Phone Number Validation
      if (this.currentValue == undefined || this.currentValue.length == 0) {
        this.isPhoneRequired = true;
        return;
      }
      else if (this.currentValue.length < 10) {
        this.isInvalidPhone = true;
        return;
      }

      //Dialing Phone
      let phoneNumber = this.currentValue;
      if (phoneNumber) {
        phoneNumber = `+${this.paramPhoneCountryCode}${phoneNumber}`;
        this.callingPhoneNumber = phoneNumber;

        //Main Calling Feature
        await this._acsService.startCall(phoneNumber);

        //Start Voice Text
        this._voiceService.startSpeach();

        //Start Recording Voice
        this.startRecording();

        //Getting ACS Messages
        this.validationMessage = this._acsService.printCallMessage;
        this.dialerCallInProgress = this._acsService.serviceCallInProgress;

        //DB Loging
        this.addPhoneCallDBLog(TransactionMode.AddData);
      }
    }
  }

  async onCallEnd() {
    if (this.dialerCallInProgress) {
      this.dialerCallInProgress = false;

      //Reset Dialer
      this.onResetDialer();

      //ACS EndCall
      await this._acsService.endCall();

      //Updaing ACS Message
      this.validationMessage = this._acsService.printCallMessage;

      //Stop Voice Text
      this._voiceService.stopSpeach();

      //Stop Voice Recording
      this.stopRecording();

      //DB Loging
      this.addPhoneCallDBLog(TransactionMode.EditData);
    }
    // this._transcriptionService.stopTranscription();
  }

  async onResetDialer() {
    this.isPhoneRequired = false;
    this.isInvalidPhone = false;
    const phoneCallValue = this.currentValue;
    this.validationMessage = '';
    if (phoneCallValue != "") {
      this.updateValue('');
    }
  }

  updateValue(value) {
    this.currentValue = value;
    this.onTouch();
    this.onChange(this.currentValue);
  }

  writeValue(value: string): void {
    if (value) {
      this.currentValue = value;
    }
  }
  //#endregion


  //#region Phone Recording
  startRecording() {
    if (!this.isRecording) {
      this.isRecording = true;
      this._recordingService.startRecording();
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this._recordingService.abortRecording();
    }
  }

  stopRecording() {
    if (this.isRecording) {
      this._recordingService.stopRecording();
      this.isRecording = false;

      setTimeout(() => {
          console.log('Awaiting for prearing audio file.');
      }, 90000);
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
  }

  async download() {
    if (this.teste == null || this.teste == undefined && !this.isRecordingDownloadable) {
      return;
    }
    const url = window.URL.createObjectURL(this.teste.blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = this.teste.title;
    link.click();
  }
  //#endregion

}
